import React from "react"

import {Alert, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";

const ListJson = ({items, fields}) => {

    if(items == undefined) return <Alert severity={"error"}>empty object</Alert>

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>id</TableCell>
                    {fields.map(field => (
                            <TableCell>{field}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.keys(items).map((key) => (
                    <TableRow
                    >
                        <TableCell>{key}</TableCell>
                        {fields.map(field => (
                            <TableCell>{items[key]!=null?items[key][field]:'-'}</TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>

    )
}

export default ListJson
